import { render, staticRenderFns } from "./OrganizerFields.vue?vue&type=template&id=db1c1152&lang=pug"
import script from "./OrganizerFields.vue?vue&type=script&lang=ts"
export * from "./OrganizerFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports